import type { ReactNode } from "react";

import { BTText } from "@btnet/core-components/BTText";

import "./BlockScreen.less";

export interface IBlockScreenProps {
    icon: ReactNode;
    title: string;
    subtitle?: string;
    children?: ReactNode;
    action: ReactNode;
}

export const BlockScreen: React.FC<IBlockScreenProps> = ({
    icon,
    title,
    subtitle,
    children,
    action,
}) => {
    return (
        <div className="block-screen-overlay" data-testid="blockScreen">
            <div className="block-screen-card">
                <div className="block-screen-icon">{icon}</div>
                <div className="block-screen-title">
                    <BTText text={title} size="distinct-lg" />
                </div>
                {subtitle && (
                    <div className="block-screen-subtitle">
                        <BTText text={subtitle} size="normal-md" />
                    </div>
                )}
                {children}
                <div className="block-screen-action">{action}</div>
            </div>
        </div>
    );
};
